import React, { Component } from 'react'

let withObjectDetails = (ListComponent, DetailsComponent) =>{
  
  
  class WithObjectDetails extends Component
  {
    constructor(props)
    {
      super(props)
      this.state = {view: 'list', object: null}
    }

    componentWillReceiveProps(props)
    {
      this.setState({view: 'list', object: null})
    }

    openDetailView = object => {
      console.log(object)
      this.setState({view: 'details', object})
    }

    closeDetailView = () => {
      this.setState({view: 'list', object: null })
    }

    render = () => {
      if (this.state.view === 'details' && this.state.object != null)
      {
        return (<DetailsComponent object={this.state.object} onRequestClose={this.closeDetailView}/>)
      }
      else
      {
        return (<ListComponent {...this.props} onSelectObject={this.openDetailView}/>)
      }
    }
  }

  WithObjectDetails.displayName = `WithObjectDetails(${ListComponent.displayName || 'Component'})`

  return WithObjectDetails
}

export default withObjectDetails



// WEBPACK FOOTER //
// ./src/hoc/object-details.js